import { AccountService } from 'services';
import React, { useEffect, useMemo, useState } from 'react'
import { Breadcrumbs, Tabs } from 'components/navigation';
import { ShowHide } from 'components/layout';
import { AreaStorage } from 'pages/account/edit/storage/area-storage';
import { LocationStorage } from 'pages/account/edit/storage/location-storage';
import { MonthlyStorage } from 'pages/account/edit/storage/monthly-storage/MonthlyStorage';
import { useLocation, useParams } from 'react-router-dom';
import { UserAccess } from 'components/user-access/UserAccess';

export function StorageOverview(props) {
    const location = useLocation();
    const requiredAction = 'Internal';
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const { name } = location?.state || {};
    const [storageBreakdown, setStorageBreakdown] = useState({
        areaStats: [],
        locationStats: [],
        otherLocationsStats: null,
        monthlyStats: []
    });

    const areaTabKey = 'AREA_STORAGE';
    const locationTabKey = 'LOCATION_STORAGE';
    const monthlyUsageTabKey = 'MONTHLY_USAGE';

    const [selectedTabKey, setSelectedTabKey] = useState(monthlyUsageTabKey);

    const onTabClick = (tabIndex) => {
        setSelectedTabKey(tabs[tabIndex].key);
    };

    const tabs = useMemo(() => [
        { title: 'Areas', key: areaTabKey, selected: selectedTabKey === areaTabKey },
        { title: 'Locations', key: locationTabKey, selected: selectedTabKey === locationTabKey },
        { title: 'Monthly Usage', key: monthlyUsageTabKey, selected: selectedTabKey === monthlyUsageTabKey }
    ], [selectedTabKey]);

    useEffect(() => {
        AccountService.getStorageBreakdown(id).then(b => {
            setStorageBreakdown(b);
            setLoading(false);
        })
    }, [id]);

    return (
        <UserAccess
            perform={requiredAction}
            yes={() =>
                <>
                    <Breadcrumbs items={props.breadcrumbs} />
                    <div>
                        <div>
                            <h1>Storage for {name}</h1>
                        </div>
                        <Tabs tabs={tabs} onClick={onTabClick} loading={loading} />
                        <ShowHide
                            evaluator={selectedTabKey === areaTabKey}
                            show={(
                                <AreaStorage areaStorage={storageBreakdown.areaStats} loading={loading} />
                            )}
                        />
                        <ShowHide
                            evaluator={selectedTabKey === locationTabKey}
                            show={(
                                <LocationStorage locationStorage={storageBreakdown.locationStats} otherLocationStorage={storageBreakdown.otherLocationsStats} loading={loading} accountId={+id} />
                            )}
                        />
                        <ShowHide
                            evaluator={selectedTabKey === monthlyUsageTabKey}
                            show={(
                                <MonthlyStorage monthlyStorageData={storageBreakdown.monthlyStats} loading={loading} />
                            )}
                        />
                    </div>
                </>
            }
        />
    );
}